function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 0C18.6279 0 24 5.37212 24 12C24 18.6279 18.6279 24 12 24C5.37212 24 0 18.6279 0 12C0 5.37212 5.37212 0 12 0Z",
  fill: "#F0B90B"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M6.5951 11.9995L6.60375 15.1726L9.2999 16.7591V18.6168L5.02586 16.1101V11.0716L6.5951 11.9995ZM6.5951 8.82644V10.6755L5.0249 9.74664V7.8976L6.5951 6.96875L8.17298 7.8976L6.5951 8.82644ZM10.4259 7.8976L11.9961 6.96875L13.5739 7.8976L11.9961 8.82644L10.4259 7.8976Z",
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M7.72974 14.5149V12.6572L9.29993 13.5861V15.4351L7.72974 14.5149ZM10.4259 17.4245L11.9961 18.3534L13.574 17.4245V19.2736L11.9961 20.2024L10.4259 19.2736V17.4245ZM15.8259 7.8976L17.3961 6.96875L18.974 7.8976V9.74663L17.3961 10.6755V8.82644L15.8259 7.8976ZM17.3961 15.1726L17.4047 11.9995L18.9749 11.0707V16.1091L14.7009 18.6159V16.7582L17.3961 15.1726Z",
  fill: "white"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2701 14.5139L14.7 15.4341V13.5851L16.2701 12.6562V14.5139Z",
  fill: "white"
});
var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M16.2701 9.48438L16.2788 11.3421L13.5749 12.9286V16.1094L12.0047 17.0296L10.4345 16.1094V12.9286L7.7307 11.3421V9.48438L9.30762 8.55553L11.9951 10.1498L14.699 8.55553L16.2769 9.48438H16.2701ZM7.72974 6.31226L11.9961 3.79688L16.2701 6.31226L14.6999 7.24111L11.9961 5.64688L9.29993 7.24111L7.72974 6.31226Z",
  fill: "white"
});
function SvgBsc(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsc);
export default __webpack_public_path__ + "static/media/bsc.080352fbe0c42d0b6e7937c45d3314c0.svg";
export { ForwardRef as ReactComponent };